"use client";
import style from './datepicker.module.scss';
import { isMatch, parse, subYears } from 'date-fns';
import ReactDatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {de} from 'date-fns/locale/de';
import {srLatn} from 'date-fns/locale/sr-Latn';
import {fr} from 'date-fns/locale/fr';
import {it} from 'date-fns/locale/it';
import {enGB} from 'date-fns/locale/en-GB';
import { useLocale, useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

// registerLocale('de', de);
registerLocale('sr', srLatn);
// registerLocale('fr', fr);
// registerLocale('it', it);
registerLocale('en', enGB);

interface Props {
    selectedDate?: string,
    open: boolean,
    onOpenCloseCalendar: (open: boolean) => void,
    onDateSelect: (date: Date) => void,
    minDate?: Date;
    maxDate?: Date;
    openToDate?: Date;
    showTimeInput?: boolean;
}

const Datepicker = ({ selectedDate, open, onOpenCloseCalendar, onDateSelect, minDate, maxDate, openToDate, showTimeInput = false }: Props) => {
    const lang = useLocale();
    const t = useTranslations();
    // console.log(openToDate)
    const [counter, setCounter] = useState<number>(0);
    // console.log(selectedDate)
    useEffect(() => {
        if(!showTimeInput && counter == 1){
            onOpenCloseCalendar(false);
            return;
        };
        if(!open) {
            setCounter(0);
        }
        if(counter == 2){
            onOpenCloseCalendar(false);
        }
    }, [counter, open, showTimeInput]);
    return (
        <ReactDatePicker
            selected={
                selectedDate && 
                (isMatch(selectedDate, 'dd.MM.yyyy HH:mm') || isMatch(selectedDate, 'dd.MM.yyyy'))
                ? 
                (showTimeInput ? 
                    parse(selectedDate, 'dd.MM.yyyy HH:mm', new Date()) 
                    : 
                    parse(selectedDate, 'dd.MM.yyyy', new Date()) 
                ) 
                : 
                subYears(new Date(), 18)}
            placeholderText="Click to select a date"
            onChange={(ev: Date) => {onDateSelect(ev ?? new Date()); setCounter(prev => prev + 1)}}
            dateFormat={showTimeInput ? "Pp" : "dd.MM.yyyy"}
            wrapperClassName={`${style.wrapper}`}
            customInput={<div className={style.invisibleInput}></div>}
            showYearDropdown
            dateFormatCalendar="MMMM"
            yearDropdownItemNumber={100}
            scrollableYearDropdown
            open={open}
            minDate={minDate}
            maxDate={maxDate}
            popperClassName={`${style.popper} ${showTimeInput ? style.time : ''} ${showTimeInput ? 'withTime' : ''}`}
            openToDate={openToDate ?? undefined}
            onClickOutside={(e) => onOpenCloseCalendar(false)}
            locale={lang}
            showTimeSelect={showTimeInput}
            timeIntervals={1}
            timeFormat='HH:mm'
            timeCaption={t('time')}
            shouldCloseOnSelect={false}
            minTime={new Date(new Date().setHours(0, 0, 0, 0))}
            maxTime={new Date()}
        />
    )
}

export default Datepicker